<template>
  <transaction-details-template
    header-icon="shopping_discount"
    @close="$emit('close')"
  >
    <div slot="title" v-text="displayTitle"></div>
    <div slot="summary" v-text="formattedAmount"></div>

    <template slot="content">
      <div v-if="isSetupPayment" :class="$style.setup">
        <h4 v-text="$t('transaction.content.setup.payment')"></h4>
        <help-link
          v-color="'violet'"
          source="https://help.capusta.space/bill/setup_payment"
        />
      </div>

      <sender-information
        :sender="senderContent"
        :transaction="transaction"
      />

      <template v-if="isShownDeclaration">
        <hr :class="$style.delimiter" />
        <transaction-declaration
          :transaction="transaction"
          :permission="permission"
        />
      </template>
    </template>

    <div v-if="permission" slot="footer" :class="$style.footer">
      <!-- TODO: CPME-3857 Переделать передачу параметра href для router-link -->
      <link-button
        v-p-t="20"
        v-p-b="20"
        :href="`/report/generation/${transaction.public_id}`"
        variant="transparent"
        target="_blank"
      >
        <base-icon
          v-color:violet
          v-m-r="10"
          name="file_file-text"
        />
        <span
          v-color:violet
          :class="$style.footerLink"
          v-text="$t('common.report')"
        />
      </link-button>
    </div>
  </transaction-details-template>
</template>

<script>
import { mapState } from 'vuex';

import { formatAmount } from 'lib/utils/amount';
import { formatDateToCustomDateFormat } from 'lib/utils/date';

import TildaParamsService from 'services/tilda';
import TransactionDeclarationService from 'services/transaction/declaration';

import LinkButton from 'molecules/common/LinkButton';
import SenderInformation from 'molecules/transaction/details/SenderInformation';
import TransactionDeclaration from 'organisms/transaction/declaration/TransactionDeclaration';
import TransactionDetailsTemplate from 'templates/transaction/details/TransactionDetailsTemplate';

import HelpLink from 'molecules/HelpLink';

import { DATE_TIME_FORMAT } from 'definitions/dates';

export default {
  name: 'PartnerTransactionDetails',
  components: {
    LinkButton,
    SenderInformation,
    TransactionDeclaration,
    TransactionDetailsTemplate,
    HelpLink,
  },
  props: {
    transaction: {
      type: Object,
      required: true,
    },
    permission: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    displayTitle() {
      const formattedDate = formatDateToCustomDateFormat(this.transaction.created_at, DATE_TIME_FORMAT);

      return `${this.$t('common.transfer')} — ${formattedDate}`;
    },
    formattedAmount() {
      const { amount, commission, currency } = this.transaction;

      return formatAmount(amount + commission, currency);
    },
    isShownDeclaration() {
      const checkDeclared = TransactionDeclarationService.checkDeclared(this.transaction);
      const checkAllowDeclaring = TransactionDeclarationService.checkAllowDeclaring(this.MERCHANT_INFO, this.transaction);

      if (this.permission) {
        return checkAllowDeclaring || checkDeclared;
      }

      return checkDeclared;
    },
    senderContent() {
      return {
        name: this.transaction.partnerProjectName,
        email: this.transaction.partnerMerchantEmail,
        description: this.$t(this.transaction.description),
      };
    },
    isSetupPayment() {
      return TildaParamsService.getSubscriptionTokenBinding(this.transaction.additional_params);
    },
    ...mapState(['MERCHANT_INFO']),
  },
};
</script>

<style lang="sass" module>
  .delimiter
    height: 1px
    margin: 20px 0
    border-color: rgba(39, 40, 60, 0.1)

  .footer
    +size(100%)

  .footerLink
    +font-type('semi-bold', 14, 24)
</style>
